import { Text } from "@radix-ui/themes";
import { FC, JSX } from "react";
import { Link } from "react-router-dom";
import { ToastContentProps } from "react-toastify";

const PrecisionGameToastClose: FC<ToastContentProps> = ({
  closeToast,
}): JSX.Element => {
  return (
    <div onClick={closeToast}>
      <Text as="p">
        🎉 Tæt på! Du er nu med i lodtrækningen om et par{" "}
        <Text weight="bold"> Sony Inzone Buds gaming in-ear høretelefoner</Text>{" "}
        til en værdi af 1.799 kr.{" "}
        <Link
          to="/profile-settings"
          style={{ color: "black", textDecoration: "underline" }}
          onClick={closeToast}
        >
          Indtast din email adresse så vi kan kontakte dig.{" "}
        </Link>
      </Text>
    </div>
  );
};

export default PrecisionGameToastClose;
